export default {
  id: 'how-scenarios-work',
  title: 'How Scenarios Work',
  content: `## How Scenarios Work

Each ACT scenario is a real historical trading setup — a moment in time when a specific technical signal fired on an NSE stock, presented to you as if it is happening now.

---

## What a Scenario Shows You

When you open a scenario, you see:

| Element | Description |
|---|---|
| Stock symbol | Which NSE stock the setup is on |
| Signal type | The scanner that fired (e.g., BREAKOUT_20D_HIGH, ORB_BREAKOUT) |
| Pre-signal chart | Candles from before the signal — what you would have seen in real time |
| Indicators | RSI, volume ratio, trend direction (vs SMA50), MACD direction |
| Signal date | The date the signal was detected on (historical) |

The outcome — what happened after the signal — is hidden until after you submit your decision.

---

## The Decision

After reviewing the setup, you choose one of three actions:

| Decision | When to use it |
|---|---|
| **Enter** | The setup meets your criteria — you would take this trade |
| **Wait** | You need more confirmation — the setup is not quite there yet |
| **Skip** | The setup does not meet your criteria — you would not trade this |

There is no "correct" answer shown before you decide. The ACT engine determines the correct answer from the historical outcome after you submit.

---

## The Trade Plan

After making your decision, you fill in your trade plan:

- **Entry price** — at what price you would enter
- **Stop loss** — where you would exit if wrong
- **Target** — where you would take profit
- **Quantity** — how many shares
- **Conviction level** — LOW, MEDIUM, or HIGH
- **Reason tags** — why you made this decision (FOMO risk, Low volume, Strong trend, etc.)

> The trade plan is the most important part of ACT. A decision without a plan is just a guess. The plan forces you to think through the trade before you see whether you were right.

---

## Viewing the Outcome

Once submitted, the outcome candles are revealed — you see exactly what happened to the stock after the signal.

You see:
- Whether the trade hit Target, Stop Loss, or neither within the outcome window
- The correct decision in hindsight (Enter or Skip)
- A plain-English verdict explaining the outcome
- Your score across the four dimensions

---

## 60-Day No-Repeat Rule

Scenarios that appeared in the last 60 days are excluded from daily selection. With 170+ intraday and 40+ swing scenarios in the pool, repetition is rare.

If the available pool runs low, the system automatically falls back to the full historical pool.

---

## Completion Tracking

Each completed scenario shows a green checkmark. Tapping a completed scenario shows the outcome and your original plan again — useful for reviewing your past decisions.

All 20 daily scenarios reset at **midnight IST**.`,
};
